<template>
	<nuxt-link :to="item.filename ? localePath(`/${item.filename}`) : item.link" class="slick-item columns column3">
		<div class="slick-slide-content">
			<h3>{{ item.header }}</h3>
			<p>{{ item.tagline }}</p>
			<span>
				{{ rooms ? $t('viewThisRoom') : item.button ? item.button : $t('viewThisPackage') }}
				<font-awesome-icon icon="fa-light fa-arrow-right-long" size="1x" />
			</span>
		</div>

		<div class="image-container">
			<picture>
				<source
					v-if="item.overviewImageWebp || item.imageWebp || item.imageOverviewPortraitWebp"
					:srcset="item.overviewImageWebp || item.imageWebp || item.imageOverviewPortraitWebp"
					type="image/webp"
				/>
				<source :srcset="item.overviewImage || item.image || item.imageOverviewPortrait" />
				<img
					loading="lazy"
					:src="item.overviewImage || item.image || item.imageOverviewPortrait"
					:alt="item.overviewImageAlt || item.imageAlt || item.imageOverviewPortrait || ''"
				/>
			</picture>
		</div>
	</nuxt-link>
</template>

<script setup>
defineProps({
	item: { type: Object, required: true },
	localePath: { type: Function, required: true },
	rooms: { type: Boolean, default: false },
});
</script>
